import Select from '../interaction/select/index';

function clearAllSelect(): void {
    Select.clear();
    Select.panelSelectAsync();
}

export {
    clearAllSelect
};
